import { Component, OnInit, ViewChild } from '@angular/core';
import { GenService } from 'app/shared/gen-ser.service';
import { DataService } from 'app/shared/dataservice.service';
import { ModalDirective } from 'ngx-bootstrap';
import { ErrorPopupComponent } from 'app/common/error-popup/error-popup.component';
import { NotificationsService } from 'angular2-notifications';
import { GenResponse, DailyToken, ProductionReviewMonitoring, DailyTokenItem, PSMToken, ProductionReview, ProdReviewDayToken } from 'app/shared/misc-classes';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-monthly-prod-plan',
  templateUrl: './monthly-prod-plan.component.html',
  styleUrls: ['./monthly-prod-plan.component.css']
})
export class MonthlyProdPlanComponent implements OnInit {

  currMonthDtObj: Date = new Date();
  mId: string = "ce48f02a-a091-4cb5-4759-a6b99b61eb9f";
  selView: number = 1;
  isLoading: boolean = false;
  isLoaded: boolean = false;
  isFailed: boolean = false;
  failMessage: string = '';
  editType: string = '';
  editToken:string = '';
  editHeader: string = '';
  editParam1:any;
  editParam2:any;
  areChangesMade: boolean = false;
  prodReviewObj: ProductionReviewMonitoring;
  ProdReviewDayTokenObj: ProdReviewDayToken;
  editRow: ProductionReview;
  daywiseItemList: Array<DailyToken>;

  @ViewChild('childModal') public childModal: ModalDirective;
  @ViewChild('copyModal') public copyModal: ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup: ErrorPopupComponent;

  constructor(public _dataService: DataService,private _activatedRoute:ActivatedRoute, private _notify: NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Monthly Production Review";
    // this.loadMonthData();
    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
    });
  }

  setView(_viewIndex: number) {
    this.selView = _viewIndex;
  }
  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }

  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadProdReviewMontring(this.currMonthDtObj).subscribe((_Prod: ProductionReviewMonitoring) => {
      console.log(_Prod);
      if(_Prod!=null){
      this.prodReviewObj = _Prod;

        this.loadDateData();          
        let _tmpDailyTokenList: Array<DailyToken> = [];
        for (var i = 0; i < this.prodReviewObj.dayTokens.length; i++) {
          let _tmpDate:Date = this.prodReviewObj.dayTokens[i].selDate;
          let _tmpDailyTokens:Array<DailyTokenItem> = [];            
          let _indexer:number = 0;
          this.prodReviewObj.dayTokens[i].dateTokens.forEach((_tmpObj:ProductionReview) => {
            _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.productId,0), this.getIdObj(_tmpDate,_indexer),''));
            _indexer++;
          });
          _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
        }

        this.daywiseItemList = _tmpDailyTokenList;
      this.isLoaded = true;
      this.isLoading = false;
      this.isFailed = false;
      }
      else{
        this.isLoaded = false;
        this.isLoading = false;
        this.isFailed = true;
        this.failMessage = "Failed to get data from database, try again";
      }
    });
  }

  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  getProductName(_prodId: string): string {
    if (_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  private getDisplayTokenName(_custId:string,_quantity:number){
    return this._dataService.getProductName(_custId) ;
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
  getData(option){
    if(option) return option
    return '-'
  }

  loadDateData(): void {
    let _tmpDPHDayToken:ProdReviewDayToken = this.prodReviewObj.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.prodReviewObj.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.prodReviewObj.getDateToken(this.currMonthDtObj);
    }
    this.ProdReviewDayTokenObj = _tmpDPHDayToken;
  }
  dataEdited(){
    switch(this.editToken){
      // case "rowedit":      
      //     this.editParam1.product = this.editRow.productId;
      //     this.editParam1.scheduleMnth = this.editRow.scheduleMnth;
      //     this.editParam1.tillDatePrdction = this.editRow.tillDatePrdction;
      //     this.editParam1.balanceQty = this.editRow.balanceQty;
      //     this.editParam1.ystrdyProductin = this.editRow.ystrdyProductin;
      //     this.editParam1.tdayProdctonPlan = this.editRow.tdayProdctonPlan;
      //     this.editParam1.dateTestedQty = this.editRow.dateTestedQty;
      //     this.editParam1.dateGreenSticker = this.editRow.dateGreenSticker;
      //     this.editParam1.creationDate = this.editRow.creationDate
      // break;
      // case "newrow":
      //   this.prodStatusObj.addDateToken(new Date(this.currMonthDtObj),new PSMToken(this.editRow.productId,this.editRow.scheduleMnth,this.editRow.tillDatePrdction,this.editRow.balanceQty,this.editRow.ystrdyProductin,this.editRow.tdayProdctonPlan,this.editRow.dateTestedQty,this.editRow.dateGreenSticker,this.editRow.balanceGreenStickerQty,this.editRow.creationDate));
      // break;
      // case "date":
      //   this.prodStatusObj.monthDate = this.editDate;
      //   this.currMonthDtObj = this.editDate;
      // break
    }
    this.areChangesMade = true;
    this.hideChildModal();
  }

  saveData(_sendMail: boolean): void {
    if (this.validateData() == true) {
      this._dataService.saveProdReviewMonitoring(this.prodReviewObj, _sendMail)
        .subscribe((resp: GenResponse) => {
          if (resp.status == DataService.statusFail) {
            if (resp.errorCode == DataService.staleDataCode) {
              this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
            } else {
              this._notify.error('Failure', resp.details, this._dataService.failureOptions);
            }
          }
          else {
            this._notify.success('Success', resp.details, this._dataService.successOptions);
            this.loadMonthData();
          }

        });
    }
  }

  public addNewProdRow(_newRowToken: string, _dayIndex: number) {
    switch (_newRowToken) {
      case "newrow":
        this.showChildModal(_newRowToken, null, null);
        this.editType = 'newrow';
        break;
    }
  }

  public showChildModal(_editToken: string, _param1: any, _param2: any): void {
    switch (_editToken) {
      case "rowedit":
        this.editRow = _param1.cloneSelf();
        this.editType = _editToken;
        this.editHeader = "Edit Production Review (" + this.formatHeaderDate(this.ProdReviewDayTokenObj.selDate) + ")";
        break;
      case "newrow":
        this.editRow = new ProductionReview(null, null, null, null, null, null, null, null);
        this.editType = _editToken;
        this.editHeader = "Add Production Review (" + this.formatHeaderDate(this.ProdReviewDayTokenObj.selDate) + ")";
        break;
      case "date":
      // this.editDate = this.prodStatusObj.monthDate;
      // this.editType = 'date';
      // this.editHeader = "Edit Date";
      // break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }

  hideChildModal(){
    this.childModal.hide();
  }

  validateData(): boolean {
    return true;
  }

  hasEditAccess(_pid: string) {
    return this._dataService.hasEditAccess(this.mId, _pid);
  }

  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }

  public prevMonthSel(): void {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  nextMonthSel() {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }

  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
      // this.copySelDate.setDate(this.currMonthDtObj.getDate()-1);
      
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();      
      // this.copySelDate.setDate(this.currMonthDtObj.getDate()-1);
    }
  }
  formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }
  formatDate(_date: Date): string {
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MM-YYYY");
    }
    return '-';
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

}
